import { motion } from "framer-motion";
import { Card } from "./ui/card";
import { skills } from "../data/portfolioData";

export const SkillsSection = () => {
  return (
    <section
      id="skills"
      className="py-20 sm:py-24 lg:py-32 bg-[hsl(var(--background))]"
      data-testid="skills-section"
    >
      <div className="mx-auto px-4 sm:px-6 lg:px-10 max-w-7xl">
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold mb-4" data-testid="skills-title">
            Expertise
          </h2>
          <p className="text-lg text-[hsl(var(--muted-foreground))] max-w-2xl mx-auto" data-testid="skills-subtitle">
            Core competencies honed through years of digital marketing and automation
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="skills-grid">
          {skills.map((skill, index) => (
            <motion.div
              key={skill.name}
              initial={{ y: 50, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              data-testid={`skill-item-${index}`}
            >
              <Card className="modern-card rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] p-6 h-full hover:border-[hsl(var(--primary))]/50 transition-all">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-semibold text-lg text-[hsl(var(--foreground))]" data-testid={`skill-name-${index}`}>
                    {skill.name}
                  </h3>
                  <span className="text-2xl">{skill.icon}</span>
                </div>
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <span className="font-mono text-xs text-[hsl(var(--muted-foreground))] uppercase tracking-wider">
                      Level
                    </span>
                    <span className="font-mono text-sm font-bold text-[hsl(var(--primary))]" data-testid={`skill-level-${index}`}>
                      {skill.level}
                    </span>
                  </div>
                  <div
                    className="h-2 rounded-full bg-[hsl(var(--muted))] overflow-hidden"
                    data-testid={`skill-stat-bar-${index}`}
                  >
                    <motion.div
                      initial={{ width: 0 }}
                      whileInView={{ width: `${skill.level}%` }}
                      viewport={{ once: true }}
                      transition={{ duration: 1.2, ease: [0.4, 0, 0.2, 1] }}
                      className="h-full rounded-full glow"
                      style={{ backgroundColor: `hsl(var(--primary))` }}
                    />
                  </div>
                </div>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
